import { render } from "./BackorderCart.vue?vue&type=template&id=6a05abbe"
import script from "./BackorderCart.vue?vue&type=script&lang=js"
export * from "./BackorderCart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__